<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.phone }} {{ entity.firstname }} </strong>
                </CCardHeader>
                <CCardBody>
                    <CustomerTabLinks />
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!loading">
                        <OrdersTable :list.sync="items" class="mt-3" />
                        <CPagination
                            :active-page.sync="activePage"
                            class="mt-4"
                            :pages="total"
                            align="center"
                        />
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import OrdersTable from '@/components/orders/OrdersTable';
    import CustomerTabLinks from '@/components/CustomerTabLinks';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {

        name: 'CustomerOrders',

        components: {
            loading: true,
            CustomerTabLinks,
            OrdersTable,
        },

        data() {
            return {
                entity: undefined,
                items: [],
                total: 1,
                loading: true
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
        },

        async created() {
            await this.fetch();
            this.loadData();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/customers/get/${id}`)).data;
            },
            loadData() {
                this.loading = true;
                const { id } = this.$route.params;
                const params = { page: this.activePage, pageSize: ITEMS_PER_PAGE, customer_id: id };
                this.axios
                    .get('/orders', { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                    });
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
